export function getStringLength(chars = "") {
    return chars.normalize().length;
}
